import type { ReactNode } from 'react'
import { AppSidebar } from './app-sidebar'
import { LiveActivity } from '../live-activity/live-activity'
import { readSidebarCookie } from './sidebar-cookie'
import { SidebarProvider, SidebarInset } from '../ui/sidebar'

/**
 * The authenticated app frame: the sidebar sits on the canvas, and the page
 * renders inside a floating rounded card with its own scroll. On desktop the
 * card keeps an 8px gap to the viewport and sidebar (the inset variant's
 * margin), so its height is the viewport minus 1rem. On mobile the sidebar is
 * a sheet and the card fills the screen.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <SidebarProvider defaultOpen={readSidebarCookie()}>
      <AppSidebar />
      <SidebarInset className="h-dvh overflow-hidden md:h-[calc(100dvh-1rem)] md:peer-data-[variant=inset]:rounded-2xl md:peer-data-[variant=inset]:border md:peer-data-[variant=inset]:border-border/60">
        {children}
      </SidebarInset>
      <LiveActivity />
    </SidebarProvider>
  )
}
